import { currentAccountSelector } from "./currentAccountSelector";
import { RootState } from "../../../store";

export const currentAccountParentIdSelector = (state: RootState) => {
  const account = currentAccountSelector(state);

  return account?.parent_id;
};
